import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ChatMainComponent } from './chat/chat-main/chat-main.component';

const routes: Routes = [
  // Labs home - product selection
  {
    path: '',
    loadComponent: () => import('./labs/labs-home/labs-home.component').then(m => m.LabsHomeComponent)
  },
  // Finder - Specialized home-finding AI (uses existing ChatMainComponent)
  {
    path: 'finder',
    component: ChatMainComponent
  },
  // General Chat - ChatGPT-like assistant
  {
    path: 'chat',
    loadComponent: () => import('./labs/general-chat/general-chat.component').then(m => m.GeneralChatComponent)
  },
  // Fallback
  {
    path: '**',
    redirectTo: ''
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
